import { Grid, Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { TableRowSelection } from "antd/es/table/interface";
import { FC } from "react";
import "./selectable-list.css";
import { SelectableListItem } from "./selectable-list-item";
import { DateInformationFooter } from "../date-information-footer";

export interface SelectableListDataType {
  key: React.Key;
  title: string;
  initials: string;
  timestamp: string;
  progress: string;
  schemaVersion: string;
  caseType: string;
  state: string;
}

interface SelectableListProps {
  data: SelectableListDataType[];
  selectedRecord: SelectableListDataType | undefined;
  onSelectChange: (selectedRowKeys: React.Key, caseType: string, schemaVersion: string) => void;
}
export const SelectableList: FC<SelectableListProps> = (props) => {
  const onRowChange = (selectedRowKeys: React.Key[]) => {
    if (selectedRowKeys.length === 0) {
      return;
    }
    props.onSelectChange(selectedRowKeys[0], props.data.find((r) => r.key === selectedRowKeys[0])?.caseType ?? "", props.data.find((r) => r.key === selectedRowKeys[0])?.schemaVersion ?? "");
  };

  const rowSelection: TableRowSelection<SelectableListDataType> = {
    selectedRowKeys: props.selectedRecord === undefined ? [] : ([props.selectedRecord.key] as React.Key[]),
    onChange: onRowChange,
    type: "radio",
  };
  const columns: ColumnsType<SelectableListDataType> = [
    {
      dataIndex: "name",
      render: (_, record) => <SelectableListItem data={record} />,
    },
  ];

  const selectRow = (record: SelectableListDataType) => {
    props.onSelectChange(record.key, record.caseType, record.schemaVersion);
  };

  const screen = Grid.useBreakpoint();
  const isMobile = screen.xs;

  return (
    <Table
      onRow={(record) => ({
        onClick: () => {
          selectRow(record);
        },
      })}
      style={{ backgroundColor: "transparent", width: "100%", maxHeight: isMobile ? "625px": "690px", height: isMobile ? "625px": "690px"}}
      rowSelection={rowSelection}
      columns={columns}
      dataSource={props.data}
      pagination={false}
      className={"selectable-list without-selection-column"}
      
      footer={() => (
        <DateInformationFooter
          customStyle={{
            position: "relative",
            backgroundColor: "transparent",
            background: "#f0f2f5",
            transform: isMobile ? "translate(-16px, 3px)" : "translate(-15px, -3px)",
            width: isMobile ? "unset" : '300px',
            padding: "30px 30px 50px 30px",

          }}
        />
      )}
    />
  );
};